<form [formGroup]="debtorForm">
  <ng-select
    #debtorSelect
    tabindex="0"
    [searchable]="!isMobile"
    [clearable]="false"
    [items]="debtorAccounts"
    [searchFn]="searchFilter"
    [closeOnSelect]="true"
    [markFirst]="false"
    [formControl]="debtorFormControl"
    [formControlName]="debtorFormControlName"
    [loading]="!debtorAccounts"
    [bindLabel]="'displayValue'"
    placeholder="{{
      'checkout.formBillingShipping.debtor.placeHolder' | transloco
    }}"
    [ngClass]="{
      isInvalid: invalidClass,
    }"
  >
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div class="organization-container">
        <div class="info-container">
          <span class="info-title" data-qa="company-name">{{ item.name }}</span>
          <span class="info-subtitle">
            @if (item.nameExtraInfo) {
              <span data-qa="extra-info">{{ item.nameExtraInfo }}</span>
            }
            @if (item.debtorNumber) {
              <span data-qa="company-number">{{ item.debtorNumber }}</span>
            }
          </span>
        </div>
      </div>
    </ng-template>
  </ng-select>
</form>
